/**
 * 渠道运费计算Hook
 */

import { useState, useEffect } from 'react';
import { calculateChannelShippingCost } from '../utils/pricingCalculations';

export const useChannelShipping = (
    channels: any[],
    selectedChannelId: string,
    chargeableWeight: number
) => {
    const [shippingCostCNY, setShippingCostCNY] = useState<number>(0);
    const [selectedChannelRateInfo, setSelectedChannelRateInfo] = useState<{
        name: string,
        tiers: any[],
        matchedRate: number
    } | null>(null);

    useEffect(() => {
        console.log('🔄 useChannelShipping useEffect 触发:', {
            selectedChannelId,
            channelsCount: channels.length,
            chargeableWeight
        });

        if (selectedChannelId && channels.length > 0) {
            // 使用 String() 转换确保类型匹配
            const channel = channels.find((c: any) => String(c.id) === String(selectedChannelId));

            console.log('🔍 查找渠道结果:', {
                selectedChannelId,
                found: !!channel,
                channelName: channel?.name,
                hasRateTiers: !!channel?.rate_tiers?.length
            });

            if (channel && channel.rate_tiers && channel.rate_tiers.length > 0) {
                const { costCNY, matchedRate } = calculateChannelShippingCost(
                    channel.rate_tiers,
                    chargeableWeight
                );

                console.log('✅ 计算头程运费:', {
                    channelName: channel.name,
                    chargeableWeight,
                    matchedRate,
                    costCNY
                });

                setShippingCostCNY(costCNY);

                // 保存运价信息用于显示
                setSelectedChannelRateInfo({
                    name: channel.name,
                    tiers: channel.rate_tiers,
                    matchedRate
                });
            } else {
                console.warn('⚠️ 未找到有效渠道或运价梯度');
                // 如果没有找到匹配的渠道，重置为0
                setShippingCostCNY(0);
                setSelectedChannelRateInfo(null);
            }
        } else {
            console.warn('⚠️ 缺少必要参数:', {
                hasChannelId: !!selectedChannelId,
                channelsLength: channels.length
            });
            // 如果没有选择渠道或渠道列表为空，重置为0
            setShippingCostCNY(0);
            setSelectedChannelRateInfo(null);
        }
    }, [selectedChannelId, channels, chargeableWeight]);

    return {
        shippingCostCNY,
        selectedChannelRateInfo,
    };
};
